<template>
  <div>
    <v-layout
      row
      align-center
      :style="myLayoutStyle"
    >
      <v-flex
        xs12
        sm12
        md12
        lg10
        offset-lg1
        xl8
        offset-xl2
      >
        <v-card flat>
          <v-card-text :style="myCardStyle">
            <v-btn
              v-if="$mq === 'xs' && pendingOrders.length > 0"
              block
              dark
              medium
              class="btn"
              :color="theme.btn_color_primary"
              @click="viewOrders"
            >
              {{ $t('orders') }}
            </v-btn>
            <delivery-progress-bar v-if="mode.isDelivery && cartQty > 0 && this.deliveryConfig.discountData.length > 0"></delivery-progress-bar>
            <banner v-if="banners.length > 0"></banner>
            <promotion-div
              v-if="(displayVouchersTo.all || (displayVouchersTo.members && isMember)) && banners.length === 0"
              class="mt-1 mb-2"
            />
            <about-us v-if="this.hasAdditionalInfo"></about-us>
            <dining-mode-title v-if="diningTitleMode === 1" />
            <div
              v-if="catList.length > 0"
              class="mt-1 mb-2"
            >
              <div v-if="categoryListMode === 0">
                <div
                  v-for="(c, index) in catList"
                  :key="index"
                >
                  <cat-list
                    :cat="c"
                    :open-panel="expand1stCat(index)"
                  />
                </div>
              </div>
              <div v-else>
                <main-cat-list style="margin-top: -3px;" />
              </div>
            </div>
            <progress-bar :show="catList.length === 0" style="margin-top: 80px;" />
            <menu-item-dialog v-if="menuItemDialog && !(iOS && inIframe)" />
            <voucher-item-dialog v-if="isMember && vouchers.length > 0 && voucherItemDialog && !(iOS && inIframe)" />
<!--            <voucher-item-dialog v-if="(isMember || vouchers.length > 0) && voucherItemDialog && !(iOS && inIframe)" />-->
            <promotion-dialog v-if="!(iOS && inIframe)" />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DiningModeTitle from '~/components/DiningModeTitle'
import PromotionDiv from '~/components/PromotionDiv'
import CatList from '~/components/CatList'
import MainCatList from '~/components/MainCatList'
import MenuItemDialog from '~/components/MenuItemDialog'
import VoucherItemDialog from '../components/VoucherItemDialog'
import PromotionDialog from '~/components/PromotionDialog'
import DeliveryProgressBar from '../components/DeliveryProgressBar'
import Banner from '../components/Banner'
import AboutUs from '../components/AboutUs'

export default {
  name: 'menu-view',
  metaInfo () {
    return {
      title: this.config.full_name,
      meta: [
        { name: 'keywords', content: this.seo.keywords },
        { name: 'description', content: this.seo.description },
        { property: 'og:url', content: this.siteUrl },
        { property: 'og:type', content: 'restaurant.menu' },
        { property: 'og:title', content: this.seo.description },
        { property: 'og:site_name', content: this.seo.description }
      ]
    }
  },
  components: {
    'dining-mode-title': DiningModeTitle,
    'promotion-div': PromotionDiv,
    'cat-list': CatList,
    'main-cat-list': MainCatList,
    'menu-item-dialog': MenuItemDialog,
    'voucher-item-dialog': VoucherItemDialog,
    'promotion-dialog': PromotionDialog,
    'delivery-progress-bar': DeliveryProgressBar,
    'banner': Banner,
    'about-us': AboutUs
  },
  data () {
    return {
      timer: null
    }
  },
  computed: {
    ...mapGetters('config', [
      'config', 'theme', 'timeout', 'iOS', 'inIframe', 'displayVouchersTo', 'language',
      'allowMultiLang', 'diningTitleMode', 'categoryListMode', 'seo', 'siteUrl', 'mode',
      'deliveryConfig', 'memberToken', 'guestId', 'loyaltyGroupId', 'rid'
    ]),
    ...mapGetters('menu', [
      'catList', 'menuItemDialog'
    ]),
    ...mapGetters('member', [
      'isMember'
    ]),
    ...mapGetters('cart', [
      'cartQty'
    ]),
    ...mapGetters('order', [
      'pendingOrders'
    ]),
    ...mapGetters('voucher', [
      'voucherItemDialog', 'vouchers'
    ]),
    ...mapGetters('banner', [
      'banners'
    ]),
    myLayoutStyle () {
      return {
        marginLeft: '-16px',
        marginRight: '-16px',
        marginBottom: '-16px',
        backgroundColor: this.theme.bg_color
      }
    },
    myCardStyle () {
      return {
        backgroundColor: this.theme.bg_color,
        paddingTop: 0,
        paddingBottom: 0
      }
    },
    hasAdditionalInfo () {
      // just additional info to be display under banner in html
      return this.config.additional_info
    }
  },
  methods: {
    expand1stCat (index) {
      return (index === 0)
    },
    viewOrders () {
      this.$router.push({ name: 'orders' })
    },
  },
  async mounted () {
    // if (this.memberToken) {
    //   this.$store.dispatch('responseMessage', {
    //     type: 'success',
    //     text: this.memberToken,
    //     timeout: 1800
    //   })
    // }
    // Load font and emit it to be listened in Main.vue
    this.$bus.$emit('refreshFontName', this.theme.font)

    // Change language
    if (!this.allowMultiLang) {
      this.$store.dispatch('config/resetLanguage')
    }
    if (this.$i18n.locale != this.language && (this.language == 'en-SG' || this.language == 'cn-SG')) {
      this.$i18n.locale = this.language
    }

    const timeout = this.timeout || 300
    this.timer = setInterval(async () => {
      await this.$store.dispatch('fetchMenuCats')
    }, timeout * 1000)
  },
  beforeDestroy () {
    // window.removeEventListener('beforeunload', this.reinitialise)
    clearInterval(this.timer)
  },
  beforeRouteLeave (to, from, next) {
    // When browser / phone's back button is clicked, it should go back to menu
    if (this.menuItemDialog) {
      this.$store.dispatch('menu/hideMenuItemDialog')
      next(false)
    } else {
      next()
    }
  }
}
</script>

<style scoped>
.btn {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/menu.vue